// Exact `'true'` only: this flag swaps in the mock wallet connector and waives address
// screening, so `NEXT_PUBLIC_E2E_TEST=false` must not read as truthy.
export const isE2E_Next = process.env.NEXT_PUBLIC_E2E_TEST === 'true'
